<template>
	<div class="context-color" :class="{'--readonly': readonly}" @click.prevent.stop="onClickColor">
		<div class="context-color__itself --bg-accent" :class="item.color"></div>
	</div>
</template>

<script>
import Config from "@/config";
import base from "@/mixins/base";

/**
 * Цветовая полоса контекста слева от строки списка.
 * При наведении расширяется, по клику открывает выбор цвета.
 */
export default {
	name: "context-color",
	mixins: [base],
	props: {
		item: {
			type: Object,
		},
		/** Если true - цвет нельзя менять, полоса только отображается */
		readonly: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		onClickColor(event) {
			if (this.readonly) return;

			this.dispatch("ui/colorSelector", {
				event,
				// список может быть внутри диалога (например, теги в диалоге группы) - меню должно быть поверх него
				zIndex: Config.ZINDEX_OVER_DIALOGS + 1,
			}).then(async res => {
				await this.do("context/userUpdate", {
					contextId: this.item.auth || this.item.id,
					params: {
						color: res?.css || null // res can be null!
					}
				});
				this.$emit("changed", res);
			});
		},
	},
}
</script>

<style lang="scss">
.context-color {
	z-index: 2;
	position: absolute;
	left: 0;
	top: 0;
	width: 12px;
	height: 100%;
	cursor: pointer;
	@include transition();

	&:hover:not(.--readonly) {
		background: map-get($blue, "lighten-4");

		.context-color__itself {
			width: 100%;
		}
	}

	&.--readonly {
		cursor: inherit;
	}

	&__itself {
		width: 4px;
		height: 100%;
		@include transition();
	}
}
</style>
